import type { Artifact } from '@alatzidis/core'

export const NOTES_ARTIFACTS: Artifact[] = []

export const RENDER_ARTIFACTS: Artifact[] = [
  {
    number: 'r·01',
    title: 'Cornell Box',
    blurb:
      'A room, a few solids, a lamp — and five ways of working out where the light goes. Whitted ray tracing, path tracing, bidirectional path tracing, progressive photon mapping, and CAP, our own: ray-traced first frames that dissolve into bidirectional, with photons merged in once it has settled. All on your GPU, all converging while you watch. Drag the objects and lamps around, change what they are made of, and see which algorithm finds the caustic under the glass ball first.',
    href: '/render/cornell-box',
  },
  {
    number: 'r·02',
    title: 'Room',
    blurb:
      'A room you furnish yourself — walls with windows and doors, a sofa, shelves, a glass table, lamps and the sun outside — rendered by the same five algorithms. Walk through it with W A S D, put things down where you are looking, and watch the light find its way round the corners. Kept in your browser; export it as a file.',
    href: '/render/room',
  },
]
